import { GraphQLClient } from 'graphql-request';
import {
  SessionExpiredError,
  isNotAuthenticatedError,
  isSessionExpired,
  markSessionExpired
} from 'lib/auth/sessionExpiry';
export { gql } from 'graphql-request';

const GRAPHURL = '/api/graphql';
const HASURA_CLAIMS_ROLE_KEY = 'x-hasura-role';

/**
 * Teaches every browser GraphQL call to recognise an expired Auth0 session.
 *
 * graphql-request 4.x has no response middleware — that landed in v5 — so the
 * one place all of this traffic converges is `request()` on the client this
 * module hands out. Wrapping it here covers the generated SDK (`clientSdk`)
 * and the ~30 hooks that call `getGraphQLClient()` directly, without a single
 * call site having to know about session expiry.
 *
 * `rawRequest`/`batchRequests` are intentionally not wrapped: nothing in this
 * app calls them, and the generated SDK emits `client.request` exclusively.
 */
class SessionAwareGraphQLClient extends GraphQLClient {
  async request(...args) {
    // Short-circuit once the session is known dead. Every one of these calls
    // would 401 anyway, and answering locally is what keeps react-query and
    // SWR retries off the network.
    if (isSessionExpired()) {
      throw new SessionExpiredError();
    }
    try {
      return await super.request(...args);
    } catch (error) {
      if (isNotAuthenticatedError(error)) {
        markSessionExpired();
        // Swap the raw ClientError for the typed one so a call site doing
        // `notification('error', error.message)` shows a sentence rather than
        // the "GraphQL Error (Code: 401): {...}" blob users were seeing.
        throw new SessionExpiredError();
      }
      throw error;
    }
  }
}

const hasuraBareClient = new SessionAwareGraphQLClient(GRAPHURL, {
  headers: {}
});

export const getGraphQLClient = (role) => {
  if (role) {
    const client = new SessionAwareGraphQLClient(GRAPHURL, {
      headers: {}
    });
    client.setHeader(HASURA_CLAIMS_ROLE_KEY, role);
    return client;
  }
  return hasuraBareClient;
};

// export const hasuraUserClient = (role) => {
//   let token;

//   if (typeof window !== 'undefined') {
//     token = tokenSvc.getCurrentToken();
//     if (token) {
//       token = tokenSvc.clearIfExpired(token);
//     }

//     if (!token) {
//       fetch('/api/auth/token')
//         .then((res) => res.json())
//         .then((fullToken) => {
//           tokenSvc.saveToken(fullToken.idToken);
//           return fullToken.idToken;
//         });
//       token = tokenSvc.getCurrentToken();
//     }
//   }

//   let headers = {
//     ...(token && { Authorization: `Bearer ${token}` }),
//   };

//   if (role) {
//     headers['x-hasura-role'] = role;
//   }

//   return new GraphQLClient(publicRuntimeConfig.GRAPHQL_ENDPOINT, {
//     headers,
//   });
// };
